<template>
  <div id="app">
    <transition name="el-fade-in-linear">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app{
  height: 100%;
}
*{
  margin: 0px;
  padding: 0px;
  font-family: KaiTi;
/* 何大哥要求字体加粗 */
  font-weight: bold;
}
 /* 更改表格颜色效果不是很好 */
/* .el-table--border,.el-table--group,.el-table td,.el-table th.is-leaf{
    border-color: #606266 !important;
}
.el-table::before,.el-table__fixed-right::before, .el-table__fixed::before,.el-table--border::after, .el-table--group::after, .el-table::before{
  background-color: #606266 !important;
} */
body,html{
  height: 100%;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-thumb {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: rgba(0, 0, 0, 0.1);
}
.el-form-item {
  margin-bottom: 15px !important;
}
</style>
